export default (yardList = []) => yardList.find((yard) => yard.isHomeYard === 'Y')
